import React, { FC, useEffect, useState } from "react";
import Card from "../Card/Card";
import { EntityComplaint } from "types/EntityComplaint";
import { GetDistrictDetails, GetDistrictsForMap } from "api/apiService";
import ListItem from "components/controls/ListItem/ListItem";
import { useYearFromRedux } from "utils/utilsLogic";
import {
  ActiveComponentEnum as ActiveComponentType,
  ActiveComponentEnum,
} from "enums/enums";
import Const from "const.json";
import { useAppSelector } from "../../redux/hooks";
import Map from "components/controls/Map/Map";
import useApi from "hooks/useApi";
import WithApi from "components/ui/WithApi/WithApi";

const DistrictOfResidenceForComplainant: FC = () => {
  const { comparisonTextToLastYear } = useYearFromRedux();
  const { period } = useAppSelector((state) => state.general);
  const [selectedDistrict, setSelectedDistrict] =
    useState<EntityComplaint | null>(null);
  const [activeComponent, setActiveComponent] = useState(
    ActiveComponentType.Map
  );

  const { callApi, data, loading, error } = useApi<EntityComplaint[]>(GetDistrictsForMap);

  useEffect(() => {
    setActiveComponent(ActiveComponentType.Map)
    callApi()
  }, [period]);

  const handleNavigation = (
    componentName: ActiveComponentType,
    complaintEntity: EntityComplaint = null
  ) => {
    setActiveComponent(componentName);
    setSelectedDistrict(complaintEntity || null);
  };

  return (
    <div>
      {activeComponent === ActiveComponentType.Map && (
        <Card
          header={Const.districtOfResidenceForComplainant}
          subHeader={comparisonTextToLastYear}
          components={[
            <WithApi data={data} loading={loading} error={error}><Map districts={data} handleNavigation={handleNavigation} /></WithApi>,
          ]}
        />
      )}
      {activeComponent === ActiveComponentType.EntityDetails && (
        <Card
          components={[
            <ListItem
              onNavigate={handleNavigation}
              navigateTo={ActiveComponentEnum.Map}
              complaint={selectedDistrict}
              fetchDetails={GetDistrictDetails}
              isShowDetails={true}
              isShowLogo={false}
            />,
          ]}
        />
      )}
    </div>
  );
};

export default DistrictOfResidenceForComplainant;
